import { createAction, createReducer } from "@reduxjs/toolkit";

export interface SortConfig {
    key: 'full_nummer' | 'tekst' | 'vermeldingen' | 'bestekken' | 'versie_jaarversie';
    direction: 'asc' | 'desc';
}

export interface BepalingFilterState {
    beschrijving: string;
    hoofdstukFilter: string;
    paragraafFilter: string;
    artikelFilter: string;
    lidFilter: string;
    // FIXED: leeg = alle jaarversies samengeteld (zoals voorheen), een waarde scopet de
    // lijst/export naar precies dat jaar.
    jaarversieFilter: string;
    // NIEUW: "release versie" (Bestek.versie) — cascadeert onder jaarversie.
    releaseFilter: string;
    activePage: number;
    sortConfig: SortConfig | null;
}

const initialState: BepalingFilterState = {
    beschrijving: "",
    hoofdstukFilter: "",
    paragraafFilter: "",
    artikelFilter: "",
    lidFilter: "",
    jaarversieFilter: "",
    releaseFilter: "",
    activePage: 1,
    sortConfig: null,
};

const setBeschrijvingAction = createAction<string>('bepaling-filter/set-beschrijving');
const setHoofdstukFilterAction = createAction<string>('bepaling-filter/set-hoofdstuk-filter');
const setParagraafFilterAction = createAction<string>('bepaling-filter/set-paragraaf-filter');
const setArtikelFilterAction = createAction<string>('bepaling-filter/set-artikel-filter');
const setLidFilterAction = createAction<string>('bepaling-filter/set-lid-filter');
const setJaarversieFilterAction = createAction<string>('bepaling-filter/set-jaarversie-filter');
const setReleaseFilterAction = createAction<string>('bepaling-filter/set-release-filter');
const setActivePageAction = createAction<number>('bepaling-filter/set-active-page');
const setSortConfigAction = createAction<SortConfig | null>('bepaling-filter/set-sort-config');
const resetAction = createAction('bepaling-filter/reset');

export const bepalingFilterReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setBeschrijvingAction, (state, action) => {
            state.beschrijving = action.payload;
            state.activePage = 1;
        })
        .addCase(setHoofdstukFilterAction, (state, action) => {
            state.hoofdstukFilter = action.payload;
            state.paragraafFilter = "";
            state.artikelFilter = "";
            state.lidFilter = "";
            state.activePage = 1;
        })
        .addCase(setParagraafFilterAction, (state, action) => {
            state.paragraafFilter = action.payload;
            state.artikelFilter = "";
            state.lidFilter = "";
            state.activePage = 1;
        })
        .addCase(setArtikelFilterAction, (state, action) => {
            state.artikelFilter = action.payload;
            state.lidFilter = "";
            state.activePage = 1;
        })
        .addCase(setLidFilterAction, (state, action) => {
            state.lidFilter = action.payload;
            state.activePage = 1;
        })
        .addCase(setJaarversieFilterAction, (state, action) => {
            state.jaarversieFilter = action.payload;
            // Release cascadeert onder jaarversie.
            state.releaseFilter = "";
            state.activePage = 1;
        })
        .addCase(setReleaseFilterAction, (state, action) => {
            state.releaseFilter = action.payload;
            state.activePage = 1;
        })
        .addCase(setActivePageAction, (state, action) => {
            state.activePage = action.payload;
        })
        .addCase(setSortConfigAction, (state, action) => {
            state.sortConfig = action.payload;
            state.activePage = 1;
        })
        .addCase(resetAction, (state) => {
            state.beschrijving = "";
            state.hoofdstukFilter = "";
            state.paragraafFilter = "";
            state.artikelFilter = "";
            state.lidFilter = "";
            state.jaarversieFilter = "";
            state.releaseFilter = "";
            state.activePage = 1;
            state.sortConfig = null;
        });
});

export const bepalingFilterActions = {
    set_beschrijving: setBeschrijvingAction,
    set_hoofdstuk_filter: setHoofdstukFilterAction,
    set_paragraaf_filter: setParagraafFilterAction,
    set_artikel_filter: setArtikelFilterAction,
    set_lid_filter: setLidFilterAction,
    set_jaarversie_filter: setJaarversieFilterAction,
    set_release_filter: setReleaseFilterAction,
    set_active_page: setActivePageAction,
    set_sort_config: setSortConfigAction,
    reset: resetAction,
};